<template>
  <div class="loading">
    <div class="icon" :class="{ loadingAnimation: loading }"></div>
    <div class="title">加载中...</div>
  </div>
</template>

<script>
export default {
  name: "loading",
  components: {},
  props: {
    loading: false,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.loading {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;

  display: flex;
  align-items: center;

  font-size: 14px;
  color: #333333;
}
.icon {
  width: 20px;
  height: 20px;
  background-image: url(../../../../static/svg/template-material-lib/common/loading.svg);
  background-repeat: repeat;
  background-size: cover;
}

.title {
  margin-left: 6px;
}

.loadingAnimation {
  transform-origin: center;
  animation: loading 0.8s steps(8, end) infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/loading.vue